import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from '../views/Index.vue';
import ThankYou from '../views/ThankYou.vue';
import NotFound from '../views/NotFound.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
  },
  {
    path: '/thank-you',
    name: 'thankYou',
    component: ThankYou,
    props: true,
  },
  {
    path: '/not-found',
    name: 'notFound',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
